import { createContext } from "react";

const BirthControlTestContext = createContext();

export default BirthControlTestContext;
